import { render } from "./todosidebar.vue?vue&type=template&id=11a72e9d"
import script from "./todosidebar.vue?vue&type=script&lang=js"
export * from "./todosidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__